import HTTP from "@/_helpers/http";
import { DEMOACCOUNTS__API } from "@/_helpers/urls";
import { DEMOACCOUNTS__MUTATIONS } from "../mutation-types";
import { DEMOACCOUNTS__ACTIONS } from "../action-types";

// State
const state = {
  accounts: [],
  isLoading: false,
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1
  }
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [DEMOACCOUNTS__MUTATIONS.DEMOACCOUNTS](state, data) {
    state.accounts = data?.data?.accounts;
    state.pagination = data?.data?.pagination;
  },
  SET_LOADING(state, data) {
    state.isLoading = data;
  },
};

// Actions
const actions = {
  async [DEMOACCOUNTS__ACTIONS.DEMOACCOUNTS]({ commit, state }, parameter = {}) {
    try {
      commit("SET_LOADING", true);
      const {
        page = 1,
        limit = 10,
        search = ""
      } = parameter;

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(search && { search })
      }).toString();

      const response = await HTTP().get(
        `${DEMOACCOUNTS__API.DEMOACCOUNTS}${queryParams ? `?${queryParams}` : ''}`
      );
      commit(DEMOACCOUNTS__MUTATIONS.DEMOACCOUNTS, response.data);
      commit("SET_LOADING", false);
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
